<template>
  <div>
    <div class="table-responsive relative-center">
      <table class="table">
        <thead>
          <slot name="thead"></slot>
        </thead>
        <tbody :class="{ 'tbody-overlay': loading && currentPageHasData }">
          <slot name="tbody"></slot>
        </tbody>
      </table>
      <div v-if="!currentPageHasData && !loading" class="missing-data-text">Sorry, we found no data matching your filters.</div>
      <img
        v-if="loading"
        src="../../assets/loading.svg"
        alt="loading"
        :class="[
          'loading-spinner',
          'loading-spinner-big',
          {
            'loading-absolute': currentPageHasData,
          },
        ]"
      />
    </div>
    <div class="d-flex justify-content-center mb-4">
      <PaginationComponent :current-page="pagination.currentPage" :total-pages="pagination.lastPage" @update:current-page="changePage" />
    </div>
  </div>
</template>
<script lang="ts">
// @ts-nocheck
import { PaginationComponent } from '@metapic-apps/shared'

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: 'Table',
  components: { PaginationComponent },
  props: {
    loading: { type: Boolean, default: false },
    pagesWithData: { type: Array, default: () => [] },
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        perPage: 1,
        lastPage: 1,
        total: 0,
      }),
    },
    changePage: { type: Function },
  },
  computed: {
    currentPageHasData: function () {
      return this.pagesWithData[this.pagination.currentPage] && this.pagesWithData[this.pagination.currentPage].length > 0
    },
  },
}
</script>

<style lang="scss">
.box-shadow {
  -webkit-box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
}

.sort-icon {
  margin-left: 4px;
}

.table {
  border-collapse: separate; /* Use separate borders */
  border-spacing: 0 8px;
  th,
  td {
    &.align-left {
      text-align: left;
    }
    &.align-right {
      text-align: right;
    }
  }

  thead {
    th {
      vertical-align: middle;
      padding: 0 24px;
    }
  }

  tbody {
    tr {
      td {
        color: var(--primary);
        font-weight: 500;
        padding: 24px;
        border-top: 1px solid rgba(3, 30, 81, 0.04);
        border-bottom: 1px solid rgba(3, 30, 81, 0.04);
        vertical-align: middle;
        text-align: center;

        &:first-child {
          font-weight: 700;
          text-align: left;
        }
      }

      td:first-child {
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
        border-left: 1px solid rgba(3, 30, 81, 0.04);
      }

      td:last-child {
        border-right: 1px solid rgba(3, 30, 81, 0.04);
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
      }

      &:last-child td {
        margin-bottom: 0;
      }

      &:hover td {
        background: rgba(3, 30, 81, 0.02);
      }
    }
  }
}

.relative-center {
  position: relative;
  text-align: center;
}

.loading-absolute {
  position: absolute;
  top: 120px;
}

.loading-spinner-big {
  width: 64px;
  margin: 32px 0 48px;
}

.tbody-overlay::after {
  content: '';
  position: absolute;
  top: 40px;
  left: 0;
  height: calc(100% - 40px);
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.missing-data-text {
  margin: 48px 0;
  color: var(--gray);
}
</style>
